"use client";
import React, { useRef, useEffect } from "react";

const AboutSection: React.FC = () => {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    el.classList.add("reveal-hidden");

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.remove("reveal-hidden");
          el.classList.add("section-reveal");
          observer.unobserve(el);
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="about"
      ref={sectionRef}
      className="relative py-20 md:py-28 px-6"
    >
      <div className="max-w-3xl mx-auto text-center flex flex-col items-center gap-6">
        {/* Ornament */}
        <div className="ornament">
          <span className="text-accent text-xl">✦</span>
        </div>

        <span className="section-label">About Me</span>

        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl text-foreground">
          Arpita Kasar
        </h2>

        <p className="text-foreground-muted text-base md:text-lg leading-relaxed max-w-2xl font-body">
          I am a professional tarot reader, numerologist, healer, and mindset
          coach, transforming lives through spirituality and subconscious
          reprogramming. Rewire the subconscious so life feels easier. Imagine
          the best case scenario for every situation — your mind begins to
          attract solutions.
        </p>

        {/* Ornament */}
        <div className="ornament mt-4">
          <span className="text-accent text-xl">✦</span>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
